
import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

interface OtherSubjectCheckboxProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const OtherSubjectCheckbox: React.FC<OtherSubjectCheckboxProps> = ({ id, checked, onChange }) => {
  return (
    <div className="flex items-center space-x-2">
      <Checkbox 
        id={id} 
        checked={checked} 
        onCheckedChange={onChange}
      />
      <Label htmlFor={id} className="text-gray-700 cursor-pointer">
        อื่นๆ (ไม่พบหัวข้อที่ต้องการ)
      </Label>
    </div>
  );
};

export default OtherSubjectCheckbox;
